/* globals fetch, localStorage */
import Globals from '../utils/globals'
import { logException } from '../utils/AppLogger'
import { getRequestOptions } from '../utils/ApiHelper' // Removed getToken import
import { setError } from './findError'

// Fetch
export const REQUEST_MESSAGES = 'REQUEST_MESSAGES'
export const RECEIVE_MESSAGES = 'RECEIVE_MESSAGES'
export const REQUEST_MESSAGES_FAILURE = 'REQUEST_MESSAGES_FAILURE'
// Pending Messages
export const UPDATE_PENDING_MESSAGE = 'UPDATE_PENDING_MESSAGE'
export const CLEAR_PENDING_MESSAGE = 'CLEAR_PENDING_MESSAGE'
// Chat Messages
export const ADD_CHAT_MESSAGE = 'ADD_CHAT_MESSAGE'
export const ACK_ADD_CHAT_MESSAGE = 'ACK_ADD_CHAT_MESSAGE'
export const ADD_CHAT_MESSAGE_FAILURE = 'ADD_CHAT_MESSAGE_FAILURE'
// Notes Messages
export const ADD_NOTE = 'ADD_NOTE'
export const ACK_ADD_NOTE = 'ACK_ADD_NOTE'
export const ADD_NOTE_FAILURE = 'ADD_NOTE_FAILURE'
// Clear
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES'

export const requestMessages = (incidentId, agencyId, reportSchemaId) => {
  return {
    type: REQUEST_MESSAGES,
    incidentId,
    agencyId,
    reportSchemaId
  }
}

export const receiveMessages = (json) => {
  return {
    type: RECEIVE_MESSAGES,
    messages: json,
    receivedAt: Date.now()
  }
}

export const clearMessages = () => {
  return {
    type: CLEAR_MESSAGES
  }
}

export const requestMessagesFailure = (error) => {
  logException(error, {
    profile: localStorage.getItem('profile')
  })

  return {
    type: REQUEST_MESSAGES_FAILURE,
    error
  }
}

export const fetchMessages = (incidentId, agencyId, reportSchemaId, token) => {
  return dispatch => {
    let res

    if (!token) {
      console.error('messages.js - No token provided');
      return dispatch(setError(null, 'Token not found', 'No API token available. Please log in again.'));
    }

    const requestOptions = getRequestOptions(token)

    dispatch(requestMessages(incidentId, agencyId, reportSchemaId))
    console.log('[fetch messages- just before the fetch api')

    return fetch(`${Globals.apiEndpoint}/agencies/${agencyId}/report_schemas/${reportSchemaId}/reports/${incidentId}/messages`, requestOptions)
      .then(response => {
        res = response
        return response.json()
      })
      .then(json => {
        console.log("[fetchMessages] API response JSON:", json); // ✅ Log full response
        console.log("[fetchMessages] HTTP status:", res.status); // ✅ Log HTTP status
        if (res.status !== 200) {
          return dispatch(setError(res.status, res.statusText, json.message))
        } else {
          dispatch(receiveMessages(json))
        }
      })
      .catch(error => {
        dispatch(requestMessagesFailure(error))
        dispatch(setError(null, 'Network Error', error.message))
      })
  }
}

export const addChatMessage = (incidentId, agencyId, reportSchemaId, message) => {
  return {
    type: ADD_CHAT_MESSAGE,
    incidentId,
    agencyId,
    reportSchemaId,
    message
  }
}

export const postChatMessageFailure = (error) => {
  logException(error, {
    profile: localStorage.getItem('profile')
  })

  return {
    type: ADD_CHAT_MESSAGE_FAILURE,
    error
  }
}

export const ackPostChatMessage = (json) => {
  return {
    type: ACK_ADD_CHAT_MESSAGE,
    result: json,
    receivedAt: Date.now()
  }
}

export const postChatMessage = (incidentId, agencyId, reportSchemaId, message, token) => {
  return dispatch => {
    let res

    if (!token) {
      console.error('messages.js - No token provided');
      return dispatch(setError(null, 'Token not found', 'No API token available. Please log in again.'));
    }

    const defaultRequestOptions = getRequestOptions(token)
    const requestId = `chat-${Date.now()}`;
    const requestOptions = {
      method: 'POST',
      headers: {
        ...defaultRequestOptions.headers,
        'Content-Type': 'application/json',
        'X-Request-Id': requestId
      },
      body: JSON.stringify({
        type: message.type,
        message: message.message,
        sent: message.sent,
        display_name: message.display_name,
        sender_id: message.sender_id
      })
    };
     // 1) optimistic update
// 1. This is a synchronous dispatch before any network request happens
    dispatch(addChatMessage(incidentId, agencyId, reportSchemaId, message))

    // 2) network call (accept 200 **or** 201; handle 204 safely)
    // 2. This starts the async network call and returns the resulting Promise
    // this endpoint ALSO does the Push Notification in the server code for the endpoint
    const url = `${Globals.apiEndpoint}/agencies/${agencyId}/report_schemas/${reportSchemaId}/reports/${incidentId}/messages`;
    console.log('[POST/messages]', url, requestId);

       return fetch(url, requestOptions)
      .then(async (response) => {
        res = response;


     // Parse JSON only if present
        const ct = (res.headers.get('content-type') || '').toLowerCase();
        if (res.status === 204 || !ct.includes('application/json')) {
          return null; // no body
        }
        try {
          return await res.json();
        } catch (_) {
          return null; // malformed/empty body
        }
      })

     .then((json) => {
        if (!res.ok) {
          // non-2xx
          return dispatch(setError(res.status, res.statusText, (json && json.message) || 'Request failed'));
        }
        // 2xx (200/201/etc.)
        return dispatch(ackPostChatMessage(json || {}));
      })
      .catch((error) => {
        dispatch(postChatMessageFailure(error));
        return dispatch(setError(null, 'Network Error', error.message));
      });
  };
};

export const addNote = (incidentId, agencyId, reportSchemaId, message) => {
  return {
    type: ADD_NOTE,
    incidentId,
    agencyId,
    reportSchemaId,
    message
  }
}

export const postNoteMessageFailure = (error) => {
  logException(error, {
    profile: localStorage.getItem('profile')
  })

  return {
    type: ADD_NOTE_FAILURE,
    error
  }
}

export const ackPostNoteMessage = (json) => {
  return {
    type: ACK_ADD_NOTE,
    result: json,
    receivedAt: Date.now()
  }
}

export const postNoteMessage = (incidentId, agencyId, reportSchemaId, message, token) => {
  return dispatch => {
    let res

    if (!token) {
      console.error('messages.js - No token provided');
      return dispatch(setError(null, 'Token not found', 'No API token available. Please log in again.'));
    }

    const defaultRequestOptions = getRequestOptions(token)
    const requestOptions = {
      method: 'POST',
      headers: {
        ...defaultRequestOptions.headers,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        type: message.type,
        message: message.message,
        sent: message.sent,
        display_name: message.display_name,
        sender_id: message.sender_id
      })
    }

    dispatch(addNote(incidentId, agencyId, reportSchemaId, message))
    return fetch(`${Globals.apiEndpoint}/agencies/${agencyId}/report_schemas/${reportSchemaId}/reports/${incidentId}/messages`, requestOptions)
      .then(response => {
        res = response
        return response.json()
      })
      .then(json => {
        if (res.status !== 200) {
          return dispatch(setError(res.status, res.statusText, json.message))
        } else {
          dispatch(ackPostNoteMessage(json))
        }
      })
      .catch(error => {
        dispatch(postNoteMessageFailure(error))
        dispatch(setError(null, 'Network Error', error.message))
      })
  }
}

export const updatePendingMessage = (message) => {
  return {
    type: UPDATE_PENDING_MESSAGE,
    message
  }
}

export const clearPendingMessage = () => {
  return {
    type: CLEAR_PENDING_MESSAGE
  }
}